import { TApplicationState } from '../../types/redux';

export const isErrorPopupOpenedSelector = (state: TApplicationState) => state.consultantCianChat.isErrorPopupOpened;
